import type { CSSProperties } from 'react';
import sayHi from '@/assets/say-hi.webp';

/**
 * Waving user avatar — the "User say hi" Lottie, recoloured to the ERP oranges
 * and baked into one horizontal sprite strip (50 frames, 12.5 fps, 4 s loop),
 * played with CSS steps(). No animation library needed. Users who prefer
 * reduced motion see a still frame.
 */
const FRAMES = 50;
const LOOP_S = 4;

export function SayHiAvatar({ size, className = '' }: { size: number; className?: string }) {
  return (
    <span
      role="img"
      aria-label="User"
      className={`say-hi-avatar shrink-0 rounded-full ${className}`}
      style={{
        width: size,
        height: size,
        backgroundImage: `url(${sayHi})`,
        backgroundSize: `${size * FRAMES}px ${size}px`,
        '--say-hi-end': `-${size * FRAMES}px`,
        '--say-hi-steps': FRAMES,
        '--say-hi-loop': `${LOOP_S}s`,
      } as CSSProperties}
    />
  );
}
